import { css, StyleDeclarationValue } from 'aphrodite';
import { observer } from 'mobx-react';
import moment from 'moment';
import * as React from 'react';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { useAppDrawerContext } from '../../../web/components-v2/Drawer/AppDrawer';
import { useQueueLeadNote } from '../../contexts/queueLeadNote';
import { useQueue } from '../../hooks/queue';
import { SalesActivity } from '../../viewModels/leads/interfaces';
import { LeadViewModel } from '../../viewModels/leads/lead';
import { COFFEE_DRAWER_VALUE_DEAL } from '../Queue';
import { MeetingAcceptanceStatusText } from './components/MeetingAcceptanceStatusText';
import { styleSheet } from './styles';

interface IProps {
	lead: LeadViewModel;
	className?: string;
	styles?: StyleDeclarationValue[];
}

export const MeetingConfirmationDisplay: React.FC<IProps> = observer(props => {
	const { lead, className, styles = [] } = props;
	const queue = useQueue();
	const appDrawerContext = useAppDrawerContext();
	const noteSlider = useQueueLeadNote();
	const userSession = useUserSession();
	if (!lead || !lead?.nextMeeting) {
		return null;
	}

	const onClick = () => {
		const lastDeal = queue.lead?.lastDeal;
		if (lastDeal) {
			queue.lead?.loadDealForm(lastDeal.id);
			appDrawerContext.setValue(COFFEE_DRAWER_VALUE_DEAL);
			noteSlider.setShowQueueLeadNote(false);
		}
	};

	const prompt =
		lead.requiredActivity === SalesActivity.MeetingConfirmation
			? 'demo scheduled, please call to confirm'
			: 'next meeting scheduled';

	const datetime = lead.nextMeetingFormattedString || moment(lead.nextMeeting.startDate).format('ddd, M/DD/YY @ h:mmA');

	return (
		<div
			className={`${css(styleSheet.container, ...styles)} meeting-confirmation-display ${className || ''}`}
			onClick={onClick}
		>
			<div className={css(styleSheet.prompt)}>{prompt}</div>
			<div className={css(styleSheet.time)}>{datetime + ' with ' + lead.nextMeetingParticipant}</div>
			{userSession.account.isLevitateSalesCoffeeAccount && (
				<MeetingAcceptanceStatusText participants={lead.nextMeeting?.participants} />
			)}
		</div>
	);
});
